/* tr.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./tr.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@atlaskit/css';
import { Focusable } from '@atlaskit/primitives/compiled';
var styles = {
  base: "_19itglyw _4t3i1wto _kqswh2mm _hpylidpf _btyzidpf",
  selected: "_bfhkcslv _irr3quvt",
  subitem: "_bfhkm7j4",
  bodyRow: "_1r62e4h9 _12ornqa1 _1ezz1tr0 _irr3134o"
};
/**
 * __Row__
 *
 * A row primitive.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */
export var TR = function TR(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    isSelected = _ref.isSelected,
    _ref$isBodyRow = _ref.isBodyRow,
    isBodyRow = _ref$isBodyRow === void 0 ? true : _ref$isBodyRow,
    isSubitem = _ref.isSubitem;
  return /*#__PURE__*/React.createElement(Focusable, {
    as: "tr",
    isInset: true,
    tabIndex: -1,
    "aria-selected": isSelected,
    testId: testId,
    xcss: cx(styles.base, isBodyRow && styles.bodyRow, isSelected && styles.selected, isSubitem && styles.subitem)
  }, children);
};